<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H9C9.82845 2.5 10.5 3.17157 10.5 4V20C10.5 20.8285 9.82846 21.5 9 21.5H4C3.17157 21.5 2.5 20.8285 2.5 20V4Z" stroke="currentColor" />
    <path d="M13.5 4C13.5 3.17157 14.1715 2.5 15 2.5H20C20.8285 2.5 21.5 3.17157 21.5 4V9C21.5 9.82846 20.8285 10.5 20 10.5H15C14.1715 10.5 13.5 9.82846 13.5 9V4Z" stroke="currentColor" />
    <path d="M13.5 15C13.5 14.1715 14.1715 13.5 15 13.5H20C20.8285 13.5 21.5 14.1715 21.5 15V20C21.5 20.8285 20.8285 21.5 20 21.5H15C14.1715 21.5 13.5 20.8285 13.5 20V15Z" stroke="currentColor" />
  </svg>
</template>
